<!-- Admin bar component -->
<app-admin-bar></app-admin-bar>

<div class="page" [class.has-admin-bar]="isAdmin()">
    <app-header [sidebar]="sidebar"></app-header>
    <app-sidebar #sidebar></app-sidebar>
    <app-main></app-main>
    <app-modal></app-modal>
</div>
